var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('vue-snotify'),_c('nav-header',{attrs:{"logged":_vm.logged}}),(_vm.logged)?_c('nav-bar'):_vm._e(),_c('router-view',{style:(_vm.logged ? 'margin: 25px auto' : 'margin: 75px auto')}),_c('send-studies'),_c('nav-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }